import React, { useState, useEffect } from "react";
import { Button }  from 'reactstrap';
import { Bell } from "react-feather";
import moment from 'moment';

import User from "~/services/user";

const NotificationBell = ({})=> {

  const [toggle        , setToggle]       = useState(false);
  const [notifications , setNotification] = useState([]);


  useEffect(()=> {
    (async ()=> {
      setNotification(await User.getActivity());
    })();
  }, []);


  const clearNotifications = ()=> {
     User.clearActivity().then(()=> setNotification([]));
  };

  if(!notifications.length) return null;

  return (
    <div className="nav-right pull-right right-header p-0">
      <ul>
        <li className="onhover-dropdown">
          <div className="notification-box" onClick={()=> setToggle(!toggle)} >
            <Bell /> <span className="badge badge-pill badge-danger">{notifications.length}</span>
          </div>
          <ul className={`notification-dropdown onhover-show-div ${ toggle ? "active" : "" }`} style={{maxHeight:500, overflow: 'auto'}} >
            <li> <h6 className="mb-0">Notification</h6> </li>

            {notifications.map((notification, index)=>
              <li key={index}>
                <div>
                  <a href={notification.clickUrl || 'https://app.earndorado.com'} target="_blank">
                    <div>
                      <i className="fa fa-circle-o mr-3 font-info"></i>
                      {notification.title}
                      { isNaN(Date.parse(moment.unix(notification.date))) ? '' : <p className="pull-right"> { moment.unix(notification.date/1000).format("YYYY-MM-DD") } </p> }
                    </div>
                    <p >{notification.body}</p>
                  </a>
                </div>
              </li>
            )}

            <li>
              <Button color="primary" block onClick={clearNotifications}> Clear notifications </Button>
            </li>
          </ul>
        </li>

      </ul>
    </div>
  );
};

export default NotificationBell;
